import React, { useState, useEffect } from 'react';
import { FiBriefcase, FiArchive, FiMapPin, FiChevronRight } from 'react-icons/fi';
import api from '../../api/config';
import './JopArsiv.css';

const JobArsiv = () => {
    const [activeTab, setActiveTab] = useState('merkez');
    const [ilanlar, setIlanlar] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tabs = [
        { key: 'merkez',        label: 'Genel Merkez',      fetchEndpoint: '/api/merkez-ilanlar',        arsivEndpoint: (id) => `/api/arsiv/merkez-ilan/${id}` },
        { key: 'yurt-personel', label: 'Yurt Personel',     fetchEndpoint: '/api/yurt-personel-ilanlar', arsivEndpoint: (id) => `/api/arsiv/yurt-personel-ilan/${id}` },
        { key: 'yurt-yonetici', label: 'Yurt Yönetici',     fetchEndpoint: '/api/yurt-yonetici-ilanlar', arsivEndpoint: (id) => `/api/arsiv/yurt-yonetici-ilan/${id}` },
        { key: 'neva-yemek',    label: 'Neva Yemek',        fetchEndpoint: '/api/neva-yemek-ilanlar',    arsivEndpoint: (id) => `/api/arsiv/neva-yemek-ilan/${id}` },
    ];

    const activeTabConfig = tabs.find(t => t.key === activeTab);

    const fetchIlanlar = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.get(activeTabConfig.fetchEndpoint);
            setIlanlar(response.data || []);
        } catch (error) {
            console.error('İlanlar yüklenirken hata:', error);
            setError('İlanlar yüklenirken bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIlanlar();
    }, [activeTab]);

    const handleArsivle = async (ilanId, e) => {
        e.stopPropagation(); // Satır tıklama olayını engellemek için
        if (!window.confirm('Bu ilanı arşive almak ve yayından kaldırmak istediğinize emin misiniz?')) return;
        
        try {
            const response = await api.post(activeTabConfig.arsivEndpoint(ilanId));
            if (response.data.success) {
                fetchIlanlar();
                alert('İlan başarıyla arşivlendi ve yayından kaldırıldı.');
            }
        } catch (error) {
            console.error('Arşivleme hatası:', error);
            alert('İlan arşivlenirken bir hata oluştu: ' + (error.response?.data?.message || error.message));
        }
    };

    return (
        <div className="corp-dashboard">
            {/* Üst Başlık Alanı */}
            <div className="corp-header-bar">
                <div>
                    <h1>Aktif İş İlanları Yönetimi</h1>
                    <p className="subtitle">Yayındaki İlanları İzleme ve Arşivleme Paneli</p>
                </div>
            </div>

            {/* Kurumsal Departman Sekmeleri */}
            <div className="arsiv-tab-container">
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        className={`arsiv-tab-button ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* İçerik Listesi Kartı */}
            <div className="corp-content-card">
                {error && <div className="error-message">{error}</div>}

                {loading ? (
                    <div className="corporate-loader-container">
                        <div className="corp-loader"></div>
                        <span>Aktif ilanlar listeleniyor...</span>
                    </div>
                ) : (
                    <>
                        <div className="panel-meta">
                            <div className="meta-title">
                                <h2>{activeTabConfig.label} Listesi</h2>
                            </div>
                            <div className="meta-stats">
                                <FiBriefcase /> <span><strong>{ilanlar?.length || 0}</strong> Aktif İlan Yayında</span>
                            </div>
                        </div>

                        {ilanlar && ilanlar.length > 0 ? (
                            <div className="corp-list">
                                {/* Tablo Sütun Başlıkları */}
                                <div className="job-list-header">
                                    <div className="col-job-title">İlan Başlığı / Pozisyon</div>
                                    <div className="col-job-comp">Kurum / Firma</div>
                                    <div className="col-job-loc">Şehir</div>
                                    <div className="col-job-action">İşlem</div>
                                </div>

                                {/* İlan Satırları */}
                                {ilanlar.map((ilan) => (
                                    <div key={ilan.id} className="corp-list-item-job">
                                        <div className="col-job-title font-semibold">
                                            {ilan.ilan_basligi}
                                        </div>
                                        <div className="col-job-comp text-muted">
                                            {ilan.firma_adi || 'Belirtilmedi'}
                                        </div>
                                        <div className="col-job-loc text-muted">
                                            <FiMapPin style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                                            {ilan.sehir || '-'}
                                        </div>
                                        <div className="col-job-action">
                                            <button 
                                                onClick={(e) => handleArsivle(ilan.id, e)} 
                                                className="btn-job-archive"
                                            >
                                                <FiArchive /> Arşive Al
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="corp-empty-state">Bu kategoriye ait yayında olan bir iş ilanı bulunamadı.</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default JobArsiv;